/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpResponseBase } from '@angular/common/http';
import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CLIENT_INTERCEPTORS = new InjectionToken<ClientInterceptor[]>('ClientInterceptor');

export interface ClientInterceptor {
  transformResult(response: HttpResponseBase, response$: Observable<unknown>): Observable<unknown>;
}

export class ClientBase {
  private readonly clientInterceptors = inject(CLIENT_INTERCEPTORS, { optional: true });

  // This exists because we use Interface mode on NSwag which types everything as Date but doesn't actually construct Date objects.
  // It is supported by a small modification to the liquid template (see AngularClient.liquid in the WebSvc.Unity project)
  protected jsonParseReviver = (key: string, value: any) => {
    // Assume the naming convention for all date properties ends with either `date` or `_dt`.
    if (value && new RegExp(/^.*(_dt|date)$/).test(key) && typeof value === "string") {
      if (value.length == 10) {        
        // assume all dates that come back from the UI are in AK time.
        return new Date(value + " 00:00:00 GMT-0900");
      }
      return new Date(value);
    } else {
      return value;
    }
  };

  public transformResult(
    _url: string,
    response: HttpResponseBase,
    processor: (response: HttpResponseBase) => Observable<any>
  ): Observable<any> {
    let result = processor(response);

    if (this.clientInterceptors == null) {
      return result;
    }

    for (const clientInterceptor of this.clientInterceptors) {
      result = clientInterceptor.transformResult(response, result);
    }

    return result;
  }
}
